export class Param {
	constructor({ id, value }) {
		this.id = id;
		this.value = value;
	}
}